import { render, staticRenderFns } from "./TftUniversityShowdownHome.vue?vue&type=template&id=1d2bb80d&"
import script from "./TftUniversityShowdownHome.vue?vue&type=script&lang=js&"
export * from "./TftUniversityShowdownHome.vue?vue&type=script&lang=js&"
import style0 from "./TftUniversityShowdownHome.vue?vue&type=style&index=0&id=1d2bb80d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports